import React from "react";
import { Button, Menu } from "@mantine/core";

const ConnectToGisDropdownSelector: React.FC<{
  label: string;
  onConnectExisting: () => void;
  onCreateNew: () => void;
}> = ({ label, onConnectExisting, onCreateNew }) => {
  return (
    <Menu width={220} shadow="md" withinPortal>
      <Menu.Target>
        <Button size="sm" color="green" rightSection={<i className="fa fa-caret-down" />}>
          Lag lenke
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={onConnectExisting} leftSection={<i className="fa fa-link fa-fw" />}>
          Eksisterende {label}
        </Menu.Item>
        <Menu.Item onClick={onCreateNew} leftSection={<i className="fa fa-file-text-o fa-fw" />}>
          Ny {label}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default ConnectToGisDropdownSelector;
